//More/Less filters
$('.sorting-bar #filter-toggle span').click(function () {
    var $this = $(this);

    if ($(this).hasClass('more')) {
        localStorage.sortingBar = 'expanded';
        $('.sorting-bar #filters').slideDown('slow', function () {
            $this.hide().siblings().show();
        });
    } else {
        localStorage.removeItem('sortingBar');
        $('.sorting-bar #filters').slideUp('slow', function () {
            $this.hide().siblings().show();
        });
    }
});
